import React,{useState,useEffect,useCallback} from 'react';
import {Routes,Route,Link,useNavigate} from 'react-router-dom';
import {motion,AnimatePresence} from 'framer-motion';
import ServiceDetail from './ServiceDetail';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

// Icons erweitert um ChevronLeft und ChevronRight für die Navigation
const {FiArrowRight,FiMaximize2,FiX,FiZoomIn,FiChevronLeft,FiChevronRight}=FiIcons;

// Zentrale Datenhaltung für alle Services inkl. Medien für das Grid
const servicesData={
  rohbau: {
    id: 'rohbau',
    title: 'Rohbau',
    subtitle: 'Das Fundament Ihrer Zukunft',
    shortDesc: 'Vom Fundament bis zum Dachstuhl – wir bauen massiv und wertbeständig.',
    description: 'Wir schaffen das solide Grundgerüst für Ihr Bauvorhaben mit höchsten Qualitätsstandards. Unser erfahrenes Team realisiert Rohbauten aller Größenordnungen - vom Einfamilienhaus bis zum Gewerbebau.',
    image: 'https://canv.wasacon.com/rudt-bau/_assets/media/d02f8f8524167394704ee76db0a05ad1.jpg',
    video: 'https://canv.wasacon.com/rudt-bau/_assets/video/d15bd0722d69ec9507ccd5d15254038b.mp4',
    gridClass: 'md:col-span-2 md:row-span-2',
    features: [
      {title: 'Fundamente und Bodenplatten',description: 'Tragfähige Fundamente als stabiles Fundament für Ihr Bauwerk'},
      {title: 'Mauerwerk',description: 'Präzises Mauerwerk mit hochwertigen Materialien'},
      {title: 'Betonarbeiten',description: 'Fachgerechte Betonarbeiten für Stabilität und Langlebigkeit'},
      {title: 'Dachstuhl-Vorbereitung',description: 'Optimale Vorbereitung für die nachfolgenden Gewerke'}
    ],
    process: [
      'Baustelleneinrichtung',
      'Aushub & Fundament',
      'Mauerwerksaufbau',
      'Betonarbeiten',
      'Qualitätskontrolle'
    ]
  },
  betonarbeiten: {
    id: 'betonarbeiten',
    title: 'Betonarbeiten',
    subtitle: 'Form und Stabilität',
    shortDesc: 'Präzise Betonkonstruktionen für höchste Ansprüche.',
    description: 'Höchste Qualität und Präzision bei allen Betonarbeiten. Unsere Expertise umfasst sowohl Standardbetonarbeiten als auch komplexe Betonkonstruktionen.',
    image: 'https://canv.wasacon.com/rudt-bau/_assets/media/7ad47eb9e0009776126670ec2093277d.jpg',
    video: 'https://canv.wasacon.com/rudt-bau/_assets/video/72625f99f6ee755b2ff4d9216c76f3b8.mp4',
    gridClass: 'md:col-span-1 md:row-span-2',
    features: [
      {title: 'Betonfundamente',description: 'Tragfähige Fundamente für alle Bauwerkstypen'},
      {title: 'Bodenplatten',description: 'Ebene und belastbare Bodenplatten nach Norm'},
      {title: 'Stützmauern',description: 'Stabile Stützkonstruktionen für Geländesprünge'},
      {title: 'Betonreparaturen',description: 'Fachgerechte Sanierung geschädigter Betonbauteile'}
    ],
    process: [
      'Statik & Planung',
      'Schalung & Bewehrung',
      'Betonage',
      'Nachbehandlung',
      'Qualitätsprüfung'
    ]
  },
  klinkerarbeiten: {
    id: 'klinkerarbeiten',
    title: 'Klinker',
    subtitle: 'Ästhetik für die Ewigkeit',
    shortDesc: 'Hochwertige Fassaden,die Generationen überdauern.',
    description: 'Klinkerarbeiten sind eine erstklassige Lösung, um Fassaden optisch aufzuwerten und Gebäuden ein individuelles, langlebiges Erscheinungsbild zu verleihen. Durch die besondere Struktur und Farbvielfalt von Klinkern entsteht eine zeitlose Fassade, die sowohl bei Wohnhäusern als auch bei gewerblichen und öffentlichen Bauten einen positiven Eindruck hinterlässt.',
    image: 'https://canv.wasacon.com/rudt-bau/_assets/media/0c87bfd41e772cb12be78235e6f7f53e.jpg',
    gridClass: 'md:col-span-1 md:row-span-1',
    features: [
      {title: 'Klinkerfassaden',description: 'Komplette Fassadenverkleidung mit hochwertigen Klinkern'},
      {title: 'Verblendmauerwerk',description: 'Präzise Verblendung für optimalen Wetterschutz'},
      {title: 'Restaurierung',description: 'Fachgerechte Sanierung historischer Klinkerfassaden'},
      {title: 'Fugensanierung',description: 'Professionelle Erneuerung schadhafter Fugen'}
    ],
    process: [
      'Materialauswahl',
      'Vorbereitung',
      'Klinkerverlegung',
      'Verfugung',
      'Reinigung'
    ],
    // Neue erweiterte Inhalte für Klinkerarbeiten
    detailedContent: {
      properties: {
        title: 'Eigenschaften von Klinkern',
        description: 'Klinker bestehen aus gebrannten Tonsteinen, deren Poren sich beim Brennvorgang schließen. Diese hohe Dichte macht sie besonders widerstandsfähig gegen Witterungseinflüsse, frostbeständig und langlebig – sie können über Jahrzehnte hinweg ihre Optik behalten. Außerdem sind sie diffusionsoffen und bestehen aus natürlichen Rohstoffen, was sie zu einer nachhaltigen Fassadenlösung macht.'
      },
      delivery: {
        title: 'Lieferung und Kontrolle',
        points: [
          'Zugänglichkeit für den LKW sicherstellen, damit die Klinkersteine dort abgeladen werden können, wo sie später verbaut werden sollen',
          'Sofortige Kontrolle der angelieferten Menge, Farbe und Formate',
          'Prüfung auf Farbabweichungen bei Naturprodukten'
        ]
      },
      storage: {
        title: 'Lagerung vor der Verarbeitung',
        description: 'Klinkersteine sollten trocken und gut vor Regen geschützt gelagert werden, bevor sie verarbeitet werden. Nasse oder feuchte Steine lassen sich schwerer verarbeiten und beeinträchtigen die Qualität des Endergebnisses.'
      },
      processing: {
        title: 'Verarbeitung & fachgerechter Einbau',
        intro: 'Für eine gleichmäßige Farbwirkung ist es empfehlenswert, Klinker aus mehreren Paletten miteinander zu mischen – Steine aus einer Palette können aufgrund ähnlicher Position im Brennofen ähnliche Farbnuancen haben.',
        conditions: [
          'Trockene Bedingungen und geeignete Temperaturen (idealerweise zwischen 5 °C und 30 °C)',
          'Nur trockene Klinker verarbeiten',
          'Passenden Fugenmörtel gemäß Herstellerangaben verwenden',
          'Fugarbeiten nur bei trockener Witterung durchführen'
        ]
      },
      tips: {
        title: 'Tipps für ein gleichmäßiges Ergebnis',
        points: [
          'Bei mehreren Lieferungen nicht sofort alle Steine einer Lieferung verarbeiten, sondern bei der zweiten Lieferung mischen',
          'Immer eine Reserve an Klinkern zurückhalten für spätere Reparaturen oder Ergänzungen'
        ]
      }
    }
  },
  putzarbeiten: {
    id: 'putzarbeiten',
    title: 'Putzarbeiten',
    subtitle: 'Perfekte Oberflächen',
    shortDesc: 'Innen- und Außenputz für ein gesundes Wohnklima.',
    description: 'Perfekte Oberflächengestaltung durch professionelle Putzarbeiten. Von klassischem Innenputz bis hin zu modernen Wärmedämmputzsystemen.',
    image: 'https://canv.wasacon.com/rudt-bau/_assets/media/a48c25dc25792fc76761c46d1ba6d571.jpg',
    video: 'https://canv.wasacon.com/rudt-bau/_assets/video/097822a36f47d07143ede72d186f793a.mp4',
    gridClass: 'md:col-span-1 md:row-span-1',
    features: [
      {title: 'Innenputz',description: 'Glatte Oberflächen für Wände und Decken'},
      {title: 'Außenputz',description: 'Wetterfeste Außenputzsysteme'},
      {title: 'Dekorputz',description: 'Strukturputze für individuelle Gestaltung'},
      {title: 'Wärmedämmputz',description: 'Energieeffiziente Putzsysteme'}
    ],
    process: [
      'Untergrundprüfung',
      'Grundierung',
      'Putzauftrag',
      'Oberflächenfinish',
      'Trocknung'
    ]
  },
  maurerarbeiten: {
    id: 'maurerarbeiten',
    title: 'Maurerarbeiten',
    subtitle: 'Tradition & Moderne',
    shortDesc: 'Handwerkskunst,auf die Sie bauen können.',
    description: 'Moderne Techniken gepaart mit traditionellem Handwerk. Unsere Maurer beherrschen alle Aspekte des Mauerwerksbaus.',
    image: 'https://canv.wasacon.com/rudt-bau/_assets/media/791af044ab42451e28f820270d679f40.jpg',
    video: 'https://canv.wasacon.com/rudt-bau/_assets/video/668b179f9a262e8560d069db74b21f2c.mp4',
    gridClass: 'md:col-span-2 md:row-span-1',
    features: [
      {title: 'Mauerwerksbau',description: 'Präziser Aufbau von Mauerwerk aller Art'},
      {title: 'Reparaturen',description: 'Fachgerechte Reparatur schadhafter Stellen'},
      {title: 'Sanierung',description: 'Umfassende Sanierung alter Strukturen'},
      {title: 'Umbauarbeiten',description: 'Anpassung an neue Anforderungen'}
    ],
    process: [
      'Planung',
      'Materialvorbereitung',
      'Maurerarbeiten',
      'Qualitätskontrolle',
      'Übergabe'
    ]
  },
  pflasterverlegung: {
    id: 'pflasterverlegung',
    title: 'Pflasterarbeiten',
    subtitle: 'Wege & Plätze',
    shortDesc: 'Gestaltung von Außenanlagen mit Charakter.',
    description: 'Hochwertige Pflasterarbeiten für Einfahrten,Gehwege und Terrassen. Wir verlegen alle gängigen Pflastermaterialien fachgerecht.',
    image: 'https://canv.wasacon.com/rudt-bau/_assets/media/ae28306617446087eb526827f0f28121.jpg',
    video: 'https://canv.wasacon.com/rudt-bau/_assets/video/cd0295303ade1611acf4f9881b6eb8a3.mp4',
    gridClass: 'md:col-span-2 md:row-span-1',
    features: [
      {title: 'Einfahrten',description: 'Belastbare Pflasterung für Fahrzeuge'},
      {title: 'Gehwege',description: 'Rutschfeste und barrierefreie Wege'},
      {title: 'Terrassen',description: 'Ästhetische Terrassenpflasterung'},
      {title: 'Plätze',description: 'Großflächige Pflasterarbeiten'}
    ],
    process: [
      'Vermessung',
      'Unterbau',
      'Verlegung',
      'Verfugung',
      'Reinigung'
    ]
  }
};

// Gallery Images List
const rawGalleryImages=[
  "https://canv.wasacon.com/rudt-bau/_assets/media/936a1ca0c534c882060e3f800c9ca127.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/f0791e53ec1dbda9f6e94ce61e8ad5c2.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/5c44c90ab5045a0e231528682a94e279.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/575667c3abf1297d4918f6d4f787cb82.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/39b2c9f40626a09fc8879f4850b1a5a7.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/1c3df90a90100978239078e2911c5bff.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/3dbb4e34f0e1ebf365aae9c6caa2a069.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/4588c7f1387026acb8f44c80b43fe8aa.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/7f66026b9f1d9ca7dcd3c2cff736395e.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/7ad47eb9e0009776126670ec2093277d.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/00954fe8a53363dbf99a1154b05ee7f0.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/a987b447bc35c2a097cf42275b9183a6.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/791af044ab42451e28f820270d679f40.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/9fedaaedcfa322cf40e79dd8e51afa9b.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/020c54fe806933d0197e66be1bce2456.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/9a982ddee4fdffedc657de8eba02d7d2.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/baa0ed9ba802ad5a9551cf32c74cb837.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/029902eb0294dcd31280bc8d483c94d3.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/f9c18454ef9ac5de635cb25a83093c42.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/582ed49c0835a80e1f3074657a2d727f.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/bb6391d4cc80da30fac5a6680afc08eb.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/177e013ad0d840eeda974715984f52c4.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/1893a4e0ec69bda7f0d090aa62b1e029.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/d02f8f8524167394704ee76db0a05ad1.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/1c010c5a81c1ea31a678929b1e981d68.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/7ce6711aaca9847596ca29f69d907952.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/035fb2672d72e0eb3fdf6907ee134eb0.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/419c0a2e5ad20ae6ea869af773e391b5.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/81888bba7512ec2200bf2cb11ed35f95.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/7eb91bdde4c4a46fb23b32884585b158.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/14568710a9f40b9781822c1b0f79f1f7.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/e486344ba870d2a01e0d55dc1d4a673e.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/a750c11c109994480acbcc136f4b9092.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/42faabaebde3c853cbaa282ea724c022.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/7203159380be44439a0e53881d75975f.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/d5b7099f1cfcb7943bcb293356ea1e9d.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/d5cd231ba0a612c738c3fd19180edda6.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/80655daf6d9317645f27b66fc59e3f60.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/3ad3b218399ae7b777ce59152a4b22c7.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/3c2ceeb18c01153796a2eac4d2e895b5.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/8482d9e041df5476cdec963dc2a6356a.jpg",
  "https://canv.wasacon.com/rudt-bau/_assets/media/660e06405704e5ce8aa2bf5b21318da9.jpg"
];

const galleryImages=[...new Set(rawGalleryImages)];

const ServicePages=()=> {
  return (
    <Routes>
      <Route path="/" element={<ServiceOverview />} />
      {Object.values(servicesData).map((service)=> (
        <Route
          key={service.id}
          path={`/${service.id}`}
          element={<ServiceDetail service={service} />}
        />
      ))}
    </Routes>
  );
};

const ServiceOverview=()=> {
  const [hoveredId,setHoveredId]=useState(null);
  const [lightboxIndex,setLightboxIndex]=useState(null);
  const navigate=useNavigate();

  const handleCardClick=(path)=> {
    window.scrollTo(0,0);
    navigate(path);
  };

  const nextImage=useCallback((e)=> {
    e?.stopPropagation();
    setLightboxIndex((prev)=> (prev===null ? null : (prev + 1) % galleryImages.length));
  },[]);

  const prevImage=useCallback((e)=> {
    e?.stopPropagation();
    setLightboxIndex((prev)=> (prev===null ? null : (prev - 1 + galleryImages.length) % galleryImages.length));
  },[]);

  const closeLightbox=useCallback(()=> {
    setLightboxIndex(null);
  },[]);

  useEffect(()=> {
    if (lightboxIndex===null) return;
    const handleKeyDown=(e)=> {
      if (e.key==='Escape') closeLightbox();
      if (e.key==='ArrowRight') nextImage();
      if (e.key==='ArrowLeft') prevImage();
    };
    window.addEventListener('keydown',handleKeyDown);
    return ()=> window.removeEventListener('keydown',handleKeyDown);
  },[lightboxIndex,closeLightbox,nextImage,prevImage]);

  useEffect(()=> {
    if (lightboxIndex !==null) {
      document.body.style.overflow='hidden';
    } else {
      document.body.style.overflow='';
    }
    return ()=> {
      document.body.style.overflow='';
    };
  },[lightboxIndex]);

  return (
    <div className="pt-20 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <motion.div
          initial={{opacity: 0,y: 30}}
          animate={{opacity: 1,y: 0}}
          transition={{duration: 0.8}}
          className="text-center mb-16"
        >
          <h1 className="text-5xl md:text-7xl font-bold text-gray-900 mb-6 tracking-tight">
            Unsere <span className="text-[#3466ad]">Expertise</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Ein Portfolio,das auf Qualität gebaut ist. Entdecken Sie unsere spezialisierten Leistungen für Ihr nächstes Projekt.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-4 auto-rows-[300px] gap-6 mb-32">
          {Object.values(servicesData).map((service,index)=> (
            <motion.div
              key={service.id}
              initial={{opacity: 0,y: 20}}
              animate={{opacity: 1,y: 0}}
              transition={{duration: 0.5,delay: index * 0.1}}
              className={`relative group rounded-3xl overflow-hidden cursor-pointer shadow-sm hover:shadow-2xl transition-all duration-500 ${service.gridClass} bg-white`}
              onMouseEnter={()=> setHoveredId(service.id)}
              onMouseLeave={()=> setHoveredId(null)}
              onClick={()=> handleCardClick(`/leistungen/${service.id}`)}
            >
              <div className="absolute inset-0 bg-gray-900">
                <img
                  src={service.image}
                  alt={service.title}
                  className={`w-full h-full object-cover transition-opacity duration-700 ${hoveredId===service.id && service.video ? 'opacity-0' : 'opacity-60 group-hover:opacity-40 group-hover:scale-105 transition-transform duration-700'}`}
                />
                {service.video && hoveredId===service.id && (
                  <motion.video
                    initial={{opacity: 0}}
                    animate={{opacity: 0.6}}
                    className="absolute inset-0 w-full h-full object-cover"
                    autoPlay
                    muted
                    loop
                    playsInline
                  >
                    <source src={service.video} type="video/mp4" />
                  </motion.video>
                )}
              </div>

              <div className="absolute inset-0 p-8 flex flex-col justify-between z-10">
                <div className="flex justify-between items-start">
                  <div className="bg-white/10 backdrop-blur-md text-white px-4 py-1.5 rounded-full text-sm font-medium border border-white/20">
                    0{index + 1}
                  </div>
                  <div className="w-10 h-10 bg-white/10 backdrop-blur-md rounded-full flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transform translate-x-4 group-hover:translate-x-0 transition-all duration-300 border border-white/20">
                    <SafeIcon icon={FiMaximize2} className="w-5 h-5" />
                  </div>
                </div>

                <div className="transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                  <h3 className="text-3xl font-bold text-white mb-2 group-hover:text-blue-100 transition-colors">
                    {service.title}
                  </h3>
                  <div className="h-0 overflow-hidden group-hover:h-auto transition-all duration-300">
                    <p className="text-gray-200 text-sm md:text-base mb-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-100">
                      {service.shortDesc}
                    </p>
                  </div>
                  <div className="flex items-center text-white/80 group-hover:text-white text-sm font-medium mt-1">
                    <span className="mr-2">Mehr erfahren</span>
                    <SafeIcon icon={FiArrowRight} className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          viewport={{once: true}}
          transition={{duration: 0.8}}
          className="mb-20"
        >
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Impressionen</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Einblicke in unsere tägliche Arbeit und abgeschlossene Projekte.
            </p>
          </div>
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
            {galleryImages.map((src,index)=> (
              <motion.div
                key={index}
                initial={{opacity: 0,y: 20}}
                whileInView={{opacity: 1,y: 0}}
                viewport={{once: true}}
                transition={{duration: 0.5,delay: (index % 3) * 0.1}}
                className="break-inside-avoid relative group rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-zoom-in"
                onClick={()=> setLightboxIndex(index)}
              >
                <img
                  src={src}
                  alt={`Impression ${index + 1}`}
                  className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                  <div className="bg-white/90 p-3 rounded-full opacity-0 group-hover:opacity-100 transform scale-75 group-hover:scale-100 transition-all duration-300 shadow-lg">
                    <SafeIcon icon={FiZoomIn} className="w-6 h-6 text-[#3466ad]" />
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <div className="mt-20 text-center">
          <p className="text-gray-500 mb-6">Sie finden nicht,was Sie suchen?</p>
          <Link
            to="/kontakt"
            className="inline-flex items-center space-x-2 bg-white border border-gray-200 text-gray-900 px-8 py-4 rounded-full font-medium hover:border-[#3466ad] hover:text-[#3466ad] transition-all duration-300 shadow-sm hover:shadow-lg"
          >
            <span>Sprechen Sie mit uns</span>
            <SafeIcon icon={FiArrowRight} className="w-4 h-4" />
          </Link>
        </div>
      </div>

      <AnimatePresence>
        {lightboxIndex !==null && (
          <motion.div
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            className="fixed inset-0 z-[1100] bg-black/95 flex items-center justify-center p-4 md:p-8 backdrop-blur-sm"
            onClick={closeLightbox}
          >
            <button
              className="absolute top-4 right-4 md:top-8 md:right-8 text-white/70 hover:text-white transition-colors bg-white/10 hover:bg-white/20 p-3 rounded-full backdrop-blur-md z-50"
              onClick={closeLightbox}
            >
              <SafeIcon icon={FiX} className="w-8 h-8" />
            </button>

            <button
              className="absolute left-2 md:left-8 top-1/2 transform -translate-y-1/2 text-white/70 hover:text-white transition-colors bg-white/10 hover:bg-white/20 p-2 md:p-3 rounded-full backdrop-blur-md z-50 flex items-center justify-center group"
              onClick={prevImage}
            >
              <SafeIcon icon={FiChevronLeft} className="w-6 h-6 md:w-8 md:h-8 group-hover:scale-110 transition-transform" />
            </button>

            <motion.div
              key={lightboxIndex}
              initial={{opacity: 0,scale: 0.95}}
              animate={{opacity: 1,scale: 1}}
              exit={{opacity: 0,scale: 0.95}}
              transition={{duration: 0.3}}
              className="relative max-w-full max-h-full flex items-center justify-center"
              onClick={(e)=> e.stopPropagation()}
            >
              <img
                src={galleryImages[lightboxIndex]}
                alt={`Impression ${lightboxIndex + 1}`}
                className="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl"
              />
              <div className="absolute inset-y-0 left-0 w-1/4 md:hidden z-10" onClick={prevImage}></div>
              <div className="absolute inset-y-0 right-0 w-1/4 md:hidden z-10" onClick={nextImage}></div>
            </motion.div>

            <button
              className="absolute right-2 md:right-8 top-1/2 transform -translate-y-1/2 text-white/70 hover:text-white transition-colors bg-white/10 hover:bg-white/20 p-2 md:p-3 rounded-full backdrop-blur-md z-50 flex items-center justify-center group"
              onClick={nextImage}
            >
              <SafeIcon icon={FiChevronRight} className="w-6 h-6 md:w-8 md:h-8 group-hover:scale-110 transition-transform" />
            </button>

            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-white/80 bg-black/40 px-4 py-2 rounded-full backdrop-blur-sm text-sm font-medium">
              {lightboxIndex + 1} / {galleryImages.length}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ServicePages;